//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client.types';
import { useQuery, useMutation } from '@tanstack/react-query';
import type { UseQueryResult, QueryFunctionContext, UseQueryOptions, QueryClient, QueryKey, MutationKey, UseMutationOptions, UseMutationResult, QueryMeta, MutationMeta } from '@tanstack/react-query';
import { trimArrayEnd, isParameterObject, getBaseUrl, addMetaToOptions } from './helpers';
import type { QueryMetaContextValue } from 'react-query-swagger';
import { QueryMetaContext } from 'react-query-swagger';
import { useContext } from 'react';
import * as Client from './SearchClient'
export { Client };
import type { AxiosRequestConfig } from 'axios';

export type SearchSearchQueryParameters = {
  search?: string | undefined ;
  offset?: number | null | undefined ;
  limit?: number | null | undefined ;
  sortBy?: string | null | undefined ;
  sortOrder?: Types.SortOrder | undefined ;
}

export type AdvancedSearchSearchQueryParameters = {
  search?: string | undefined ;
  categories?: Types.SearchCategory[] | null | undefined ;
  offset?: number | null | undefined ;
  limit?: number | null | undefined ;
  sortBy?: string | null | undefined ;
  sortOrder?: Types.SortOrder | undefined ;
}

export function searchUrl(search?: string | undefined, offset?: number | null | undefined, limit?: number | null | undefined, sortBy?: string | null | undefined, sortOrder?: Types.SortOrder | undefined): string {
  let url_ = getBaseUrl() + "/api/search?";
if (search === null)
    throw new Error("The parameter 'search' cannot be null.");
else if (search !== undefined)
    url_ += "Search=" + encodeURIComponent("" + search) + "&";
if (offset !== undefined && offset !== null)
    url_ += "Offset=" + encodeURIComponent("" + offset) + "&";
if (limit !== undefined && limit !== null)
    url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
if (sortBy !== undefined && sortBy !== null)
    url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
if (sortOrder === null)
    throw new Error("The parameter 'sortOrder' cannot be null.");
else if (sortOrder !== undefined)
    url_ += "SortOrder=" + encodeURIComponent("" + sortOrder) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let searchDefaultOptions: Omit<UseQueryOptions<Types.PagedResultOfSearchResultDto, unknown, Types.PagedResultOfSearchResultDto>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.PagedResultOfSearchResultDto, unknown, Types.PagedResultOfSearchResultDto>, 'queryFn'>> = {
};
export function getSearchDefaultOptions() {
  return searchDefaultOptions;
};
export function setSearchDefaultOptions(options: typeof searchDefaultOptions) {
  searchDefaultOptions = options;
}

export function searchQueryKey(dto: SearchSearchQueryParameters): QueryKey;
export function searchQueryKey(search?: string | undefined, offset?: number | null | undefined, limit?: number | null | undefined, sortBy?: string | null | undefined, sortOrder?: Types.SortOrder | undefined): QueryKey;
export function searchQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { search, offset, limit, sortBy, sortOrder,  } = params[0] as SearchSearchQueryParameters;

    return trimArrayEnd([
        'SearchClient',
        'search',
        search as any,
        offset as any,
        limit as any,
        sortBy as any,
        sortOrder as any,
      ]);
  } else {
    return trimArrayEnd([
        'SearchClient',
        'search',
        ...params
      ]);
  }
}
export function __search(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.search(
      context.queryKey[2] as string | undefined,       context.queryKey[3] as number | null | undefined,       context.queryKey[4] as number | null | undefined,       context.queryKey[5] as string | null | undefined,       context.queryKey[6] as Types.SortOrder | undefined,axiosConfig    );
}

export function useSearchQuery<TSelectData = Types.PagedResultOfSearchResultDto, TError = unknown>(dto: SearchSearchQueryParameters, options?: Omit<UseQueryOptions<Types.PagedResultOfSearchResultDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * Searches data.
 * @param search (optional) 
 * @param offset (optional) Offset of list.
 * @param limit (optional) Number of requested records.
 * @param sortBy (optional) Field name for sorting in DB (ABAS).
 * @param sortOrder (optional) Sort direction. Ascending or Descending.
 */
export function useSearchQuery<TSelectData = Types.PagedResultOfSearchResultDto, TError = unknown>(search?: string | undefined, offset?: number | null | undefined, limit?: number | null | undefined, sortBy?: string | null | undefined, sortOrder?: Types.SortOrder | undefined, options?: Omit<UseQueryOptions<Types.PagedResultOfSearchResultDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useSearchQuery<TSelectData = Types.PagedResultOfSearchResultDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.PagedResultOfSearchResultDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let search: any = undefined;
  let offset: any = undefined;
  let limit: any = undefined;
  let sortBy: any = undefined;
  let sortOrder: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ search, offset, limit, sortBy, sortOrder,  } = params[0] as SearchSearchQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [search, offset, limit, sortBy, sortOrder, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.PagedResultOfSearchResultDto, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __search(context, axiosConfig) : __search,
    queryKey: searchQueryKey(search, offset, limit, sortBy, sortOrder),
    ...searchDefaultOptions as unknown as Omit<UseQueryOptions<Types.PagedResultOfSearchResultDto, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * Searches data.
 * @param search (optional) 
 * @param offset (optional) Offset of list.
 * @param limit (optional) Number of requested records.
 * @param sortBy (optional) Field name for sorting in DB (ABAS).
 * @param sortOrder (optional) Sort direction. Ascending or Descending.
 */
export function setSearchData(queryClient: QueryClient, updater: (data: Types.PagedResultOfSearchResultDto | undefined) => Types.PagedResultOfSearchResultDto, search?: string | undefined, offset?: number | null | undefined, limit?: number | null | undefined, sortBy?: string | null | undefined, sortOrder?: Types.SortOrder | undefined) {
  queryClient.setQueryData(searchQueryKey(search, offset, limit, sortBy, sortOrder),
    updater
  );
}

/**
 * Searches data.
 * @param search (optional) 
 * @param offset (optional) Offset of list.
 * @param limit (optional) Number of requested records.
 * @param sortBy (optional) Field name for sorting in DB (ABAS).
 * @param sortOrder (optional) Sort direction. Ascending or Descending.
 */
export function setSearchDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.PagedResultOfSearchResultDto | undefined) => Types.PagedResultOfSearchResultDto) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function advancedSearchUrl(search?: string | undefined, categories?: Types.SearchCategory[] | null | undefined, offset?: number | null | undefined, limit?: number | null | undefined, sortBy?: string | null | undefined, sortOrder?: Types.SortOrder | undefined): string {
  let url_ = getBaseUrl() + "/api/search/advanced?";
if (search === null)
    throw new Error("The parameter 'search' cannot be null.");
else if (search !== undefined)
    url_ += "Search=" + encodeURIComponent("" + search) + "&";
if (categories !== undefined && categories !== null)
    categories && categories.forEach(item => { url_ += "Categories=" + encodeURIComponent("" + item) + "&"; });
if (offset !== undefined && offset !== null)
    url_ += "Offset=" + encodeURIComponent("" + offset) + "&";
if (limit !== undefined && limit !== null)
    url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
if (sortBy !== undefined && sortBy !== null)
    url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
if (sortOrder === null)
    throw new Error("The parameter 'sortOrder' cannot be null.");
else if (sortOrder !== undefined)
    url_ += "SortOrder=" + encodeURIComponent("" + sortOrder) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let advancedSearchDefaultOptions: Omit<UseQueryOptions<Types.PagedResultOfSearchResultGroupedDto, unknown, Types.PagedResultOfSearchResultGroupedDto>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.PagedResultOfSearchResultGroupedDto, unknown, Types.PagedResultOfSearchResultGroupedDto>, 'queryFn'>> = {
};
export function getAdvancedSearchDefaultOptions() {
  return advancedSearchDefaultOptions;
};
export function setAdvancedSearchDefaultOptions(options: typeof advancedSearchDefaultOptions) {
  advancedSearchDefaultOptions = options;
}

export function advancedSearchQueryKey(dto: AdvancedSearchSearchQueryParameters): QueryKey;
export function advancedSearchQueryKey(search?: string | undefined, categories?: Types.SearchCategory[] | null | undefined, offset?: number | null | undefined, limit?: number | null | undefined, sortBy?: string | null | undefined, sortOrder?: Types.SortOrder | undefined): QueryKey;
export function advancedSearchQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { search, categories, offset, limit, sortBy, sortOrder,  } = params[0] as AdvancedSearchSearchQueryParameters;

    return trimArrayEnd([
        'SearchClient',
        'advancedSearch',
        search as any,
        categories as any,
        offset as any,
        limit as any,
        sortBy as any,
        sortOrder as any,
      ]);
  } else {
    return trimArrayEnd([
        'SearchClient',
        'advancedSearch',
        ...params
      ]);
  }
}
export function __advancedSearch(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.advancedSearch(
      context.queryKey[2] as string | undefined,       context.queryKey[3] as Types.SearchCategory[] | null | undefined,       context.queryKey[4] as number | null | undefined,       context.queryKey[5] as number | null | undefined,       context.queryKey[6] as string | null | undefined,       context.queryKey[7] as Types.SortOrder | undefined,axiosConfig    );
}

export function useAdvancedSearchQuery<TSelectData = Types.PagedResultOfSearchResultGroupedDto, TError = unknown>(dto: AdvancedSearchSearchQueryParameters, options?: Omit<UseQueryOptions<Types.PagedResultOfSearchResultGroupedDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * Performs advanced action for search.
 * @param search (optional) 
 * @param categories (optional) 
 * @param offset (optional) Offset of list.
 * @param limit (optional) Number of requested records.
 * @param sortBy (optional) Field name for sorting in DB (ABAS).
 * @param sortOrder (optional) Sort direction. Ascending or Descending.
 */
export function useAdvancedSearchQuery<TSelectData = Types.PagedResultOfSearchResultGroupedDto, TError = unknown>(search?: string | undefined, categories?: Types.SearchCategory[] | null | undefined, offset?: number | null | undefined, limit?: number | null | undefined, sortBy?: string | null | undefined, sortOrder?: Types.SortOrder | undefined, options?: Omit<UseQueryOptions<Types.PagedResultOfSearchResultGroupedDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useAdvancedSearchQuery<TSelectData = Types.PagedResultOfSearchResultGroupedDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.PagedResultOfSearchResultGroupedDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let search: any = undefined;
  let categories: any = undefined;
  let offset: any = undefined;
  let limit: any = undefined;
  let sortBy: any = undefined;
  let sortOrder: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ search, categories, offset, limit, sortBy, sortOrder,  } = params[0] as AdvancedSearchSearchQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [search, categories, offset, limit, sortBy, sortOrder, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.PagedResultOfSearchResultGroupedDto, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __advancedSearch(context, axiosConfig) : __advancedSearch,
    queryKey: advancedSearchQueryKey(search, categories, offset, limit, sortBy, sortOrder),
    ...advancedSearchDefaultOptions as unknown as Omit<UseQueryOptions<Types.PagedResultOfSearchResultGroupedDto, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * Performs advanced action for search.
 * @param search (optional) 
 * @param categories (optional) 
 * @param offset (optional) Offset of list.
 * @param limit (optional) Number of requested records.
 * @param sortBy (optional) Field name for sorting in DB (ABAS).
 * @param sortOrder (optional) Sort direction. Ascending or Descending.
 */
export function setAdvancedSearchData(queryClient: QueryClient, updater: (data: Types.PagedResultOfSearchResultGroupedDto | undefined) => Types.PagedResultOfSearchResultGroupedDto, search?: string | undefined, categories?: Types.SearchCategory[] | null | undefined, offset?: number | null | undefined, limit?: number | null | undefined, sortBy?: string | null | undefined, sortOrder?: Types.SortOrder | undefined) {
  queryClient.setQueryData(advancedSearchQueryKey(search, categories, offset, limit, sortBy, sortOrder),
    updater
  );
}

/**
 * Performs advanced action for search.
 * @param search (optional) 
 * @param categories (optional) 
 * @param offset (optional) Offset of list.
 * @param limit (optional) Number of requested records.
 * @param sortBy (optional) Field name for sorting in DB (ABAS).
 * @param sortOrder (optional) Sort direction. Ascending or Descending.
 */
export function setAdvancedSearchDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.PagedResultOfSearchResultGroupedDto | undefined) => Types.PagedResultOfSearchResultGroupedDto) {
  queryClient.setQueryData(queryKey, updater);
}